import { render } from "./AddFulfillmentOverview.vue?vue&type=template&id=1433fa6a&scoped=true&ts=true"
import script from "./AddFulfillmentOverview.vue?vue&type=script&lang=ts"
export * from "./AddFulfillmentOverview.vue?vue&type=script&lang=ts"

import "./AddFulfillmentOverview.vue?vue&type=style&index=0&id=1433fa6a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1433fa6a"]])

export default __exports__